import { Component, Input, OnInit } from '@angular/core';
import { VariablesService } from '../../../../shared/services';

@Component({
  selector: 'app-urgent-banner',
  templateUrl: './urgent-banner.component.html',
  styleUrls: ['./urgent-banner.component.scss']
})
export class UrgentBannerComponent implements OnInit {

  @Input() endDate;
  @Input() config;
  language;

  constructor(
    public vars: VariablesService
  ) { }

  ngOnInit(): void {
    this.vars.languageObs.subscribe(lang => {
      this.language = lang;
    })
  }

}
